<template>
  <div
      v-if="isShowPop"
      :class="['ceiba-base-dialog-container',
       'ceiba-base-dialog--default',
       !isMobile ? 'ceiba-base-dialog--pc' : '',
        isBottomType ? 'ceiba-base-dialog-bottom' : 'ceiba-base-dialog-container'
       ]"
  >
    <transition>
      <div
          v-if="isShowPop && options.isShowMask"
          class="ceiba-base-dialog-mask"
          @click="handleClickMask"
      ></div>
    </transition>
    <div
        :class="[
        isBottomType ? 'ceiba-base-dialog-wrap-isBottom' : 'ceiba-base-dialog-wrap',
        isBottomType && onCloseAnimation ? 'ceiba-base-dialog-wrap-isBottom-close-animation' : '',
        !isBottomType && onCloseAnimation ? 'ceiba-base-dialog-wrap-close-animation' : '',
        ]"
        :style="baseDialogWrap"
    >
      <div :class="[
        isBottomType ? 'ceiba-base-dialog-main-bottom' : 'ceiba-base-dialog-main'
      ]"
           :style="mainStyle">
        <div class="ceiba-base-dialog-hd" v-if="options.header !== false">
          <slot name="header">
            <h3
                class="ceiba-base-dialog-title"
                :style="titleStyle"
                v-if="typeof options.header === 'string' && !isBottomType"
            >{{ options.header }}</h3>

            <h3
                class="ceiba-base-bottom-dialog-title"
                :style="bottomTypeTitleStyle"
                v-if="typeof options.header === 'string' && isBottomType"
            >{{ options.header }}</h3>
          </slot>
        </div>

        <div :class="[
          isBottomType ? 'ceiba-base-dialog-bd-bottom' : 'ceiba-base-dialog-bd',
          ]">
          <slot name="body"></slot>
        </div>
        <div class="ceiba-base-dialog-ft" v-if="options.fotter !== false">
          <slot name="fotter">
            <template v-if="options.confirm !== false">
              <a
                  class="ceiba-base-dialog-ft-btn-simple ceiba-base-dialog-ft-btn-simple--primary"
                  href="javascript:;"
                  @click="handleConfirm"
                  :style="options.confirmStyle"
                  v-if="typeof options.confirm === 'string'"
              >
                <span class="ceiba-base-dialog-ft-btn-simple-label">{{ options.confirm }}</span>
              </a>
              <button
                  type="button"
                  :style="options.confirmStyle"
                  v-else
                  class="ceiba-base-dialog-ft-button"
                  @click="handleConfirm"
              ></button>
            </template>
            <template v-if="options.cancel !== false">
              <a
                  class="ceiba-base-dialog-ft-btn-simple"
                  href="javascript:;"
                  @click="handleCancel"
                  :style="options.cancelStyle"
                  v-if="typeof options.cancel === 'string'"
              >
                <span class="ceiba-base-dialog-ft-btn-simple-label">{{ options.cancel }}</span>
              </a>
              <button
                  type="button"
                  :style="options.cancelStyle"
                  v-else
                  class="ceiba-base-dialog-ft-button"
                  @click="handleCancel"
              ></button>
            </template>
          </slot>
        </div>
        <template v-if="options.close !== false">
          <button
              type="button"
              :style="options.closeStyle"
              v-if="options.closeStyle && JSON.stringify(options.closeStyle) !== '{}'"
              :class="[
            options.closeLocation === 'bottom-center' ? 'ceiba-base-dialog-close-bottom-center': '',
            options.closeLocation === 'right-top' ? 'ceiba-base-dialog-close-right-top': '',
            options.closeLocation === 'top-right' ? 'ceiba-base-dialog-close-top-right': '',
            options.closeLocation === 'top-right-isBottom' ? 'ceiba-base-dialog-close-top-right-isBottom': ''

            ]"
              @click="handleClose"
          ></button>
          <a
              :class="[
            options.closeLocation === 'bottom-center' ? 'ceiba-base-dialog-close-bottom-center': '',
            options.closeLocation === 'right-top' ? 'ceiba-base-dialog-close-right-top': '',
            options.closeLocation === 'top-right' ? 'ceiba-base-dialog-close-top-right': '',
            options.closeLocation === 'top-right-isBottom' ? 'ceiba-base-dialog-close-top-right-isBottom': ''
            ]"
              href="javascript:;"
              :style="positionBottomCloseStyle"
              @click="handleClose"
              v-else
          >×</a>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
const PositionBottom =  'bottom';
const PositionCenter =  'center';
export default {
  name: 'CBaseDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      onCloseAnimation: false,
      onCloseAnimationTimeId: null,
      isShowPop: false,
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      options: Object.assign(
        {
          height: this.isMobile ? '4.8rem' : '300px',
          width: this.isMobile ? '7.2rem' : '450px',
          controlClass: '', // 自定义类名
          color: '#ffffff',
          backgroundImage: '', // 个性化弹框背景
          header: '温馨提示',
          footer: false,
          confirmStyle: '', // 个性化弹框确定按钮自定义样式
          cancelStyle: '', // 个性化弹框取消按钮自定义样式
          closeStyle: '', // 个性化弹框关闭按钮自定义样式
          confirm: false,
          cancel: false,
          close: true,
          closeLocation: 'bottom-center',
          isShowMask: true,
          maskClickable: true, // 蒙层是否点击可关闭
          isConfirmClose: true,
          titleStyle: {},
          positionType: 'center',
        },
        this.option,
      ),
    };
  },
  watch: {
    value: {
      handler(newVal, oldValue) {
        // 关闭 触发css 动画
        console.log('watch base-dialog NewValue = ', newVal, 'oldValue=', oldValue);
        if (newVal === false && !!oldValue === true) {
          this.onCloseAnimation = true;
          // 关闭
          const that = this;
          this.onCloseAnimationTimeId = setTimeout(() => {
            that.isShowPop = false;
          }, 200);
          return;
        }
        // 打开的 切换className 实现css动画
        if (newVal === true && !!oldValue === false) {
          this.onCloseAnimation = false;
          this.isShowPop = true;
        }
      },
      immediate: true,
    },
  },
  computed: {
    baseDialogWrap() {
      return  {
        width: `${this.isBottomType ? '100%' : this.options.width}`,
        height: `${this.options.height}`,
        '--onPopHeight': `-${this.options.height}`,
      };
    },
    positionBottomCloseStyle() {
      if (this.options.closeLocation === 'top-right-isBottom') {
        return  { color: this.options?.dialogStyle?.color  ??  '#ffffff',
          opacity: '0.4',
        };
      }
      return   { color: '#ffffff' };
    },
    isBottomType() {
      // 默认居中 isBottom 为了兼容 这个字段扩展性不友好 去掉
      const { positionType = PositionCenter, isBottom = false } = this.options;
      if (isBottom === true) return  true;
      return positionType === PositionBottom ;
    },
    mainStyle() {
      const styles = {
        width: `${this.isBottomType ? '100%' : this.options.width}`,
        height: `${this.options.height}`,
        color: '#ffffff',
      };
      if (this.options.dialogStyle) {
        if (this.options.dialogStyle.backgroundImage) return Object.assign(styles, this.options.dialogStyle);
        return Object.assign(styles, this.options.dialogStyle, {
          backgroundColor: '#fff',
        });
      }
      return Object.assign(styles, {
        backgroundColor: '#fff',
      });
    },
    titleStyle() {
      let color = { r: 0, g: 0, b: 0 };
      if (this.options.dialogStyle) color = this.parseColor(this.options.dialogStyle.color);
      return {
        borderBottom: `0.04rem solid rgba(${color.r},${color.g},${color.b},.3)`,
        ...this.options.titleStyle,
      };
    },
    bottomTypeTitleStyle() {
      return {
        ...this.options.titleStyle,
      };
    },
  },
  beforeDestroy() {
    // 某种情况先可能出现
    if (this.onCloseAnimationTimeId) {
      console.log('access clearTimeout onCloseAnimationTimeId on  base-dialog in beforeDestroy');
      clearTimeout(this.onCloseAnimationTimeId);
    }
  },
  methods: {
    parseColor(colorStr) {
      return {
        r: parseInt(`${colorStr.slice(1, 3)}`, 16),
        g: parseInt(`${colorStr.slice(3, 5)}`, 16),
        b: parseInt(`${colorStr.slice(5, 7)}`, 16),
      };
    },
    handleClose() {
      if (this.options.close !== false) {
        this.$emit('close');
      }
      this.close();
    },
    handleClickMask() {
      if (this.options.maskClickable) {
        this.handleClose();
      }
    },
    handleCancel() {
      if (this.options.cancel !== false) {
        this.$emit('cancel');
      }
      this.close();
    },
    handleConfirm() {
      if (this.options.confirm !== false) {
        this.$emit('confirm');
      }
      if (this.options.isConfirmClose) this.close();
    },
    close() {},
  },
};
</script>

<style lang="scss">
.ceiba-base-dialog-container {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  display: flex;
}

.ceiba-base-dialog-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1001;
  background-color: rgba(0, 0, 0, 0.7);
}

.ceiba-base-dialog-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1002;
  animation: pop-center-open 0.3s 1;
}

.ceiba-base-dialog-ft {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ceiba-base-dialog-main {
  background: no-repeat 0 0;
  background-size: 100% 100%;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 20px 0;
  box-sizing: border-box;
}

.ceiba-base-dialog-bd {
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}

.ceiba-base-dialog--default .ceiba-base-dialog-hd {
  position: relative;
  width: 75%;
  text-align: center;
}

.ceiba-base-dialog--default .ceiba-base-dialog-title {
  font-size: 0.5rem;
  height: 0.9rem;
  padding: 0.2rem 0.5rem;
  line-height: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.ceiba-base-dialog--default .ceiba-base-dialog-ft-button {
  height: 0.6rem;
  margin: 0.1rem 0.3rem;
  min-width: 2rem;
  background-size: 100% 100%;
}

.ceiba-base-dialog--default .ceiba-base-dialog-close-bottom-center {
  position: absolute;
  height: 0.6rem;
  width: 0.6rem;
  bottom: -0.7rem;
  margin: 0 auto;
  text-align: center;
  color: #ddd;
  font-size: 0.7rem;
  background-size: 100% 100%;
}

.ceiba-base-dialog--default .ceiba-base-dialog-close-right-top {
  position: absolute;
  height: 0.6rem;
  width: 0.6rem;
  right: -0.7rem;
  top: 0;
  margin: 0 auto;
  text-align: center;
  color: #ddd;
  font-size: 0.7rem;
  background-size: 100% 100%;
}
.ceiba-base-dialog--default .ceiba-base-dialog-close-top-right {
  position: absolute;
  height: 0.6rem;
  width: 0.6rem;
  top: -0.7rem;
  right: 0;
  margin: 0 auto;
  text-align: center;
  color: #ddd;
  font-size: 0.7rem;
  background-size: 100% 100%;
}

.ceiba-base-dialog--default .ceiba-base-dialog-ft-btn-simple {
  display: inline-block;
  color: #fff;
  height: 0.6rem;
  line-height: 0.6rem;
  border-radius: 0.1rem;
  margin: 0.1rem 0.3rem;
  min-width: 2rem;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  background-color: #a6a6a6;
}
.ceiba-base-dialog--default .ceiba-base-dialog-ft-btn-simple--primary {
  background-color: #0052d9;
}
// pc
.ceiba-base-dialog--pc .ceiba-base-dialog-title {
  font-size: 32px;
  height: 44px;
  padding: 0px 10px;
  line-height: 32px;
}
.ceiba-base-dialog--pc .ceiba-base-dialog-ft-btn-simple {
  height: 42px;
  line-height: 42px;
  margin: 16px 20px;
  min-width: 140px;
}
.ceiba-base-dialog--pc .ceiba-base-dialog-ft-button {
  height: 42px;
  margin: 16px 20px;
  min-width: 140px;
}

.ceiba-base-dialog--pc .ceiba-base-dialog-close-bottom-center {
  height: 40px;
  width: 40px;
  bottom: -45px;
  font-size: 40px;
}
.ceiba-base-dialog--pc .ceiba-base-dialog-close-right-top {
  height: 40px;
  width: 40px;
  right: -45px;
  top: 0;
  font-size: 40px;
}
.ceiba-base-dialog--pc .ceiba-base-dialog-close-top-right {
  height: 40px;
  width: 40px;
  top: -45px;
  right: 0;
  font-size: 40px;
}

.ceiba-base-dialog-main-bottom {
  border-radius: 0.48rem 0.48rem 0 0;
  padding: 20px 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position:center;

}


.ceiba-base-dialog-wrap-isBottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1002;
  border-radius: 15px 15px 0 0;
  animation: pop-bottom-open 0.3s 1;
}


.ceiba-base-dialog-wrap-isBottom-close-animation{
  animation: pop-bottom-close 0.3s 1;
  bottom:  var(--onPopHeight )  ;
}
// 从底部弹框出现
@keyframes pop-bottom-open
{
  0% {
    bottom: var(--onPopHeight ) ;
  }
  100% {
    bottom:0;
  }
}
// 从底部弹框消失
@keyframes pop-bottom-close
{
  0% {
    bottom:0;
  }
  100% {
    bottom: var(--onPopHeight ) ;
  }
}

@-webkit-keyframes pop-bottom-close {
  0% {
    bottom:0;
  }
  100% {
    bottom: var(--onPopHeight ) ;
  }
}

.ceiba-base-dialog-wrap-close-animation{
  animation: pop-center-close 0.3s 1;
  opacity: 0;
}

@keyframes pop-center-open{
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0, 0, 1);
    transform: scale3d(0, 0, 1);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pop-center-close{
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    -webkit-transform: scale3d(0.5, 0.5, 1);
    transform: scale3d(0.5, 0.5, 1);
  }
}

@-webkit-keyframes pop-center-close{
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    -webkit-transform: scale3d(0.5, 0.5, 1);
    transform: scale3d(0.5, 0.5, 1);
  }
}

.ceiba-base-dialog--default .ceiba-base-bottom-dialog-title {
  height: 1.2rem;
  line-height: 1.2rem;
  //padding: 0.2rem 0.5rem;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  font-size: 0.32rem;
  font-weight: 500;
  padding-left: 0.5rem;
}
// close button style
.ceiba-base-dialog--default .ceiba-base-dialog-close-top-right-isBottom {
  position: absolute;
  height: 0.04rem;
  width: 0.04rem;
  right: 0.75rem;
  top: 0.1rem;
  margin: 0 auto;
  text-align: center;
  color: #ddd;
  font-size: 0.7rem;
  background-size: 100% 100%;
}

</style>
